/*
 * Collection フィルター操作 (checkbox / price レンジ) の URL ナビゲーション。
 * サイドバーと toolbar popover の両方の markup
 * (snippets/tgtp-collection-filter-controls.liquid) を 1 つの JS で扱う。
 * checkbox は document 委譲、price は container 単位で 1 回だけ init する。
 */
(function () {
  if (window.__tgtpFilterControlsInit) return;
  window.__tgtpFilterControlsInit = true;

  /* ── Checkbox filter navigation (event delegation) ── */
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.matches || !cb.matches('[data-filter-checkbox]')) return;
    // staged (toolbar popover の複数選択): 即遷移せず「完了」ボタンで一括適用
    if (cb.closest('[data-filter-staged]')) return;

    var url = new URL(window.location.href);
    var name = cb.name;
    var value = cb.value;

    if (cb.checked) {
      url.searchParams.append(name, value);
    } else {
      var all = url.searchParams.getAll(name);
      url.searchParams.delete(name);
      all.forEach(function (v) {
        if (v !== value) url.searchParams.append(name, v);
      });
    }

    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ── Price range filter ── */
  function initPrice(container) {
    if (container.dataset.tgtpPriceInit === '1') return;
    container.dataset.tgtpPriceInit = '1';

    var rangeMin = Number(container.dataset.rangeMin);
    var rangeMax = Number(container.dataset.rangeMax);
    var paramMin = container.dataset.paramMin;
    var paramMax = container.dataset.paramMax;

    var sliderMin = container.querySelector('[data-price-range-min]');
    var sliderMax = container.querySelector('[data-price-range-max]');
    var inputMin = container.querySelector('[data-price-input-min]');
    var inputMax = container.querySelector('[data-price-input-max]');
    var rangeBar = container.querySelector('[data-price-range-bar]');
    if (!sliderMin || !sliderMax || !inputMin || !inputMax || !rangeBar) return;

    var debounceTimer = null;

    function updateRangeBar() {
      var min = Number(sliderMin.value);
      var max = Number(sliderMax.value);
      var total = rangeMax - rangeMin || 1;
      rangeBar.style.left = ((min - rangeMin) / total) * 100 + '%';
      rangeBar.style.right = ((rangeMax - max) / total) * 100 + '%';
    }

    function syncAndNavigate() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var url = new URL(window.location.href);
        var minVal = Number(sliderMin.value);
        var maxVal = Number(sliderMax.value);

        if (minVal > rangeMin) {
          url.searchParams.set(paramMin, String(Math.floor(minVal / 100)));
        } else {
          url.searchParams.delete(paramMin);
        }
        if (maxVal < rangeMax) {
          url.searchParams.set(paramMax, String(Math.floor(maxVal / 100)));
        } else {
          url.searchParams.delete(paramMax);
        }
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }, 800);
    }

    sliderMin.addEventListener('input', function () {
      if (Number(sliderMin.value) > Number(sliderMax.value)) sliderMin.value = sliderMax.value;
      inputMin.value = Math.floor(Number(sliderMin.value) / 100);
      updateRangeBar();
    });
    sliderMax.addEventListener('input', function () {
      if (Number(sliderMax.value) < Number(sliderMin.value)) sliderMax.value = sliderMin.value;
      inputMax.value = Math.floor(Number(sliderMax.value) / 100);
      updateRangeBar();
    });
    sliderMin.addEventListener('change', syncAndNavigate);
    sliderMax.addEventListener('change', syncAndNavigate);

    inputMin.addEventListener('change', function () {
      var displayMax = Math.floor(Number(sliderMax.value) / 100);
      var v = Math.max(0, Math.min(Number(inputMin.value), displayMax));
      inputMin.value = v;
      sliderMin.value = v * 100;
      updateRangeBar();
      syncAndNavigate();
    });
    inputMax.addEventListener('change', function () {
      var displayMin = Math.floor(Number(sliderMin.value) / 100);
      var displayRangeMax = Math.floor(rangeMax / 100);
      var v = Math.min(displayRangeMax, Math.max(Number(inputMax.value), displayMin));
      inputMax.value = v;
      sliderMax.value = v * 100;
      updateRangeBar();
      syncAndNavigate();
    });

    function updateZIndex() {
      if (Number(sliderMin.value) >= Number(sliderMax.value)) {
        sliderMin.style.zIndex = '3';
        sliderMax.style.zIndex = '2';
      } else {
        sliderMin.style.zIndex = '2';
        sliderMax.style.zIndex = '3';
      }
    }
    sliderMin.addEventListener('input', updateZIndex);
    sliderMax.addEventListener('input', updateZIndex);

    updateRangeBar();
    updateZIndex();
  }

  function initAllPrice() {
    document.querySelectorAll('[data-filter-price]').forEach(initPrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPrice);
  } else {
    initAllPrice();
  }

  /* toolbar popover が後から開いて price が描画済みでも、念のため再 init を公開 */
  window.tgtpInitFilterPrice = initAllPrice;
})();
